/**
 * 认证接口
 */

import instance from '@/utils/axios';

/**
 * 登录接口
 * @param {账号} username
 * @param {密码} password
 */
export function login(username, password) {
  return instance.get('/auth/login', {
    params: { username, password }
  });
}

/**
 * 获取用户详细信息
 */
export function getUserInfo() {
  return instance.get('/auth/user');
}

/**
 * 登出
 * @param {*} callback
 */
export function logout() {
  return instance.get('/auth/logout');
}

/**
 * 按钮权限
 */
export function getAuthMenu() {
  return instance.get('/auth/menu');
}

/**
 * 获取个人组织机构
 */
export function getOffice(data) {
  return instance.get('/auth/office', {
    params: {
      ...data
    }
  });
}

/**
 * 获取CD603组织机构
 */
export function getCD603Office(data) {
  return instance.get('/auth/cd603Office', {
    params: {
      ...data
    }
  });
}

/**
 * 获取cd602设备列表
 * @param {Object} data
 * @param {1} data.busiType
 * @returns
 */
export function getCd602Office(data) {
  return instance.get('/cd602-devicedata/getDevice', {
    params: { ...data }
  });
}

/**
 * 获取任务
 */
export function getTask() {
  return instance.get('/auth/task');
}

/**
 * 修改密码
 * oldPassword 旧密码
 * newPassword 新密码
 */
export function modifyPsd(data) {
  return instance.get('/auth/updatePassword', {
    params: {
      ...data
    }
  });
}

/**
 * 个性化
 */
export function profile() {
  return instance.get('/auth/profile');
}

/**
 * 修改用户信息
 */
export function modifyProfile(data) {
  return instance.post('/auth/updateUser', data);
}

/**
 * 校验邮箱
 */
export function sendEmailCode(data) {
  return instance.get('/auth/emailCode', {
    params: {
      ...data
    }
  });
}

/**
 * 通知后台当前使用语言
 */
export function syncLanguage() {
  return instance.get('/change-language');
}
